import * as yup from "yup";


export const PasswordResetSchema = yup.object().shape({
  email: yup.string().email().required("Email is required"),
  password: yup.string().required("Password is required"),
  password_confirmation: yup.string().oneOf([yup.ref("password")], "Passwords must match"),
 
});
